import {newEntityStoreHelper} from "@/store/common/entityModule";
 
export default newEntityStoreHelper(() => {}, () => {})
    .withStates({
        selectItems: [],
    })
    .withActions({
        // retrieveForSelect(context) {
        //     var url = process.env.VUE_APP_MASTER_API_URL + "master-service/master/systemInstance/findAll"
        //     context.dispatch("api/get", {url}, {root: true})
        //     .then(function(data) {
        //         var result = data.map(x => { return {value: x.id, text: x.code} })
        //         context.commit("systemInstance/setSelectItens", result, {root: true})
        //     })
        // },
        retrieveSelectOnChange(context, parameters) {
            var url = process.env.VUE_APP_MASTER_API_URL + "master-service/master/systemInstance/findById/" + parameters.id
            context.dispatch("api/get", {url}, {root: true})
            .then(function(data) {
                var result = data.map(x => { return {value: x.id, text: x.code} })
                context.commit("systemInstance/setSelectItens", result, {root: true})
                if (result.length == 0) {
                    if (parameters.type == 'filter') {
                        context.commit(parameters.mainEntity+"/setFilterAttribute", {key: 'instanceFilter', newValue: ""}, {root: true})
                    }
                    else if (parameters.type == 'entity') {
                        context.commit(parameters.mainEntity+"/setEntityAttribute", {key: 'systemInstance', newValue: ""}, {root: true})
                    }
                }
            })
        }
    })
    .withMutations({
        setSelectItens(state, data) {
            state.selectItems = data
        }
    })
    .buildStore()